var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 111,
    viewBox: "0 0 112 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7598 32.375H61.0098V64.75H51.7598V32.375ZM51.7598 69.375H61.0098V78.625H51.7598V69.375Z",
    fill: "#D50000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.28 33.7301L78.1546 10.6051C77.7259 10.1748 77.2162 9.83354 76.6551 9.60097C76.0939 9.3684 75.4922 9.24912 74.8848 9.25H37.8848C37.2773 9.24912 36.6757 9.3684 36.1145 9.60097C35.5533 9.83354 35.0437 10.1748 34.6149 10.6051L11.4899 33.7301C11.0596 34.1589 10.7183 34.6685 10.4857 35.2297C10.2532 35.7909 10.1339 36.3925 10.1348 37V74C10.1348 75.2303 10.6204 76.405 11.4899 77.2699L34.6149 100.395C35.0437 100.825 35.5533 101.166 36.1145 101.399C36.6757 101.632 37.2773 101.751 37.8848 101.75H74.8848C76.115 101.75 77.2898 101.264 78.1546 100.395L101.28 77.2699C101.71 76.8411 102.051 76.3315 102.284 75.7703C102.516 75.2091 102.636 74.6075 102.635 74V37C102.636 36.3925 102.516 35.7909 102.284 35.2297C102.051 34.6685 101.71 34.1589 101.28 33.7301ZM93.3848 72.0853L72.97 92.5H39.7995L19.3848 72.0853V38.9148L39.7995 18.5H72.97L93.3848 38.9148V72.0853Z",
    fill: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalError);
export default __webpack_public_path__ + "static/media/modalError.1cf65e4afde5039b2e3fd8bc043e127e.svg";
export { ForwardRef as ReactComponent };